<template>
    <div>

        <Editor
            :key="needReload"
            :id="props.id"
            v-model="descriptionVal"
            editorStyle="height: 150px"
            :readonly="props.readonly"
            :placeholder="props.placeholder"
            @text-change="onTextChange"
            :class="{ 'invalid-editor': props.errorMessage ?? false }"
            @paste="handlePaste"
            @load="editorLoaded"
        >
            <template #toolbar>
                <div v-if="props.hideToolbar" class="ql-formats"></div>
                <div v-else>
                    <span class="ql-formats">
                        <button class="ql-bold"></button>
                        <button class="ql-italic"></button>
                        <button class="ql-underline"></button>
                    </span>
                    <span class="ql-formats">
                        <button class="ql-list" value="ordered"></button>
                        <button class="ql-list" value="bullet"></button>
                    </span>
                    <span class="ql-formats">
                        <!--<button class="ql-link"></button>-->
                        <button class="ql-link" @click="showLinkDialog"></button>
                        <button class="ql-clean"></button>
                    </span>
                </div>
            </template>
        </Editor>
        <small class="p-invalid" v-if="props.errorMessage">{{ props.errorMessage }}</small>

        <Dialog header="Insert Link" v-model:visible="linkDialogVisible">
            <div class="p-fluid">
                <div class="p-field">
                    <label for="linkText">Text</label>
                    <InputText id="linkText" v-model="linkText" />
                </div>
                <div class="p-field">
                    <label for="linkUrl">URL</label>
                    <InputText id="linkUrl" v-model="linkUrl" />
                </div>
                <div class="p-d-flex p-jc-end">
                    <Button label="Cancel" icon="pi pi-times" @click="linkDialogVisible = false" class="p-button-text" />
                    <Button label="Insert" icon="pi pi-check" @click="insertLink" />
                </div>
            </div>
        </Dialog>
    </div>
</template>

<script setup>
import { defineEmits, defineProps, onMounted, ref } from 'vue';

const emit = defineEmits(['update:modelValue', 'text-change']);
const props = defineProps({
    id: {
        type: String,
    },
    modelValue: {
        type: String,
    },
    placeholder: {
        type: String,
    },
    readonly: {
        type: Boolean,
    },
    errorMessage: {
        type: String,
    },
    hideToolbar: {
        type: Boolean,
        default: false,
    },
});

const descriptionVal = ref(null);
const linkDialogVisible = ref(false)
const linkText = ref("")
const linkUrl = ref("")
const needReload = ref(1)

onMounted(() => {

    if (props.modelValue) {
        descriptionVal.value = props.modelValue;
    }
});

function onTextChange() {
    emit('update:modelValue', descriptionVal.value)
}

const handlePaste = (event) => {
    event.preventDefault();

    let paste = (event.clipboardData || window.clipboardData).getData("text");

    const selection = window.getSelection();
    if (!selection.rangeCount) return;
    selection.deleteFromDocument();
    selection.getRangeAt(0).insertNode(document.createTextNode(paste));
    selection.collapseToEnd();
};

function showLinkDialog() {
    linkDialogVisible.value = true
}

const editorInstanceClipboard = ref(null)

function editorLoaded(event) {
    editorInstanceClipboard.value = event.instance.clipboard
}

function insertLink() {

    const quill = editorInstanceClipboard.value.quill;

    const range = quill.getSelection();
    if (range) {
        quill.insertText(range.index, linkText.value, 'link', linkUrl.value, 'user');
    } else {
        quill.insertText(editorInstanceClipboard.value.quill.getLength(), linkText.value, 'link', linkUrl.value, 'user');
    }

    linkDialogVisible.value = false;
    linkText.value = '';
    linkUrl.value = '';

    needReload.value = needReload.value +1
}

</script>

<style>
.invalid-editor {
    border: 1px solid #f44336;
}
</style>
